export default "__VITE_ASSET__BrltG80g__"